module.exports = __webpack_public_path__ + "img/idrug-logo-blue2.9da6aa12.png";